import { createMuiTheme, StylesProvider, ThemeProvider, jssPreset } from '@material-ui/core';
import React from 'react'
import Router from "./pages/Router";
import { create } from "jss";
import rtl from 'jss-rtl'
import './assets/fonts.css'
import { RecoilRoot } from 'recoil';
import BackgroundSlideshow from 'react-background-slideshow'
import InstallPrompt from './components/pwa/InstallPrompt'


function importAll(r) {
  return r.keys().map(r);
}

const rahdariImages = importAll(require.context('./assets/backgrounds/rahdari/', false, /\.(png|jpe?g|svg)$/)).map(img => img.default)

const theme = createMuiTheme({
  direction: 'rtl',
  typography: {
    fontFamily: 'Vazir'
  }
})
const jss = create({ plugins: [...jssPreset().plugins, rtl()] })
const App = () => {
  
  return (
    <RecoilRoot>
      <StylesProvider jss={jss}>
        <ThemeProvider theme={theme}>
          {window.location.host === 'rahdari.arjanpeyman.ir' &&
            <div style={{ opacity: 0.7, zIndex: -1 }}>
              <BackgroundSlideshow images={rahdariImages} disableClick />
            </div>
          }
          <Router />
          <InstallPrompt />
        </ThemeProvider>
      </StylesProvider>
    </RecoilRoot>
  )
}

export default App